module.exports = __webpack_public_path__ + "static/media/NH_winning.6493786c.png";